/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import { NgModule } from '@angular/core';
import { CONFIG } from './env.config';
import { SnLoggerModule } from './logger/logger.module';
/**
 * Requires a `.forRoot()` specifying the {\@link Config}.
 *
 * ```
 * DevkitEnvModule.forRoot({ envUrl: '...' });
 * ```
 */
var SnEnvModule = /** @class */ (function () {
    function SnEnvModule() {
    }
    /**
     * @param {?} config
     * @return {?}
     */
    SnEnvModule.forRoot = /**
     * @param {?} config
     * @return {?}
     */
    function (config) {
        return {
            ngModule: SnEnvModule,
            providers: [{ provide: CONFIG, useValue: config }]
        };
    };
    SnEnvModule.decorators = [
        { type: NgModule, args: [{
                    imports: [SnLoggerModule.forRoot()]
                },] }
    ];
    return SnEnvModule;
}());
export { SnEnvModule };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZW52Lm1vZHVsZS5qcyIsInNvdXJjZVJvb3QiOiJuZzovL0BpbnNpZ2h0L3NlcmVuaXR5LWVudi8iLCJzb3VyY2VzIjpbImxpYi9lbnYubW9kdWxlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7QUFBQSxPQUFPLEVBQUUsUUFBUSxFQUF1QixNQUFNLGVBQWUsQ0FBQztBQUU5RCxPQUFPLEVBQUUsTUFBTSxFQUFVLE1BQU0sY0FBYyxDQUFDO0FBQzlDLE9BQU8sRUFBRSxjQUFjLEVBQUUsTUFBTSx3QkFBd0IsQ0FBQzs7Ozs7Ozs7QUFTeEQ7SUFBQTtJQVVBLENBQUM7Ozs7O0lBTmlCLG1CQUFPOzs7O0lBQXJCLFVBQXNCLE1BQWM7UUFDaEMsT0FBTztZQUNILFFBQVEsRUFBRSxXQUFXO1lBQ3JCLFNBQVMsRUFBRSxDQUFDLEVBQUUsT0FBTyxFQUFFLE1BQU0sRUFBRSxRQUFRLEVBQUUsTUFBTSxFQUFFLENBQUM7U0FDckQsQ0FBQztJQUNOLENBQUM7O2dCQVRKLFFBQVEsU0FBQztvQkFDTixPQUFPLEVBQUUsQ0FBQyxjQUFjLENBQUMsT0FBTyxFQUFFLENBQUM7aUJBQ3RDOztJQVFELGtCQUFDO0NBQUEsQUFWRCxJQVVDO1NBUFksV0FBVyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IE5nTW9kdWxlLCBNb2R1bGVXaXRoUHJvdmlkZXJzIH0gZnJvbSAnQGFuZ3VsYXIvY29yZSc7XHJcblxyXG5pbXBvcnQgeyBDT05GSUcsIENvbmZpZyB9IGZyb20gJy4vZW52LmNvbmZpZyc7XHJcbmltcG9ydCB7IFNuTG9nZ2VyTW9kdWxlIH0gZnJvbSAnLi9sb2dnZXIvbG9nZ2VyLm1vZHVsZSc7XHJcblxyXG4vKipcclxuICogUmVxdWlyZXMgYSBgLmZvclJvb3QoKWAgc3BlY2lmeWluZyB0aGUge0BsaW5rIENvbmZpZ30uXHJcbiAqXHJcbiAqIGBgYFxyXG4gKiBEZXZraXRFbnZNb2R1bGUuZm9yUm9vdCh7IGVudlVybDogJy4uLicgfSk7XHJcbiAqIGBgYFxyXG4gKi9cclxuQE5nTW9kdWxlKHtcclxuICAgIGltcG9ydHM6IFtTbkxvZ2dlck1vZHVsZS5mb3JSb290KCldXHJcbn0pXHJcbmV4cG9ydCBjbGFzcyBTbkVudk1vZHVsZSB7XHJcbiAgICBwdWJsaWMgc3RhdGljIGZvclJvb3QoY29uZmlnOiBDb25maWcpOiBNb2R1bGVXaXRoUHJvdmlkZXJzIHtcclxuICAgICAgICByZXR1cm4ge1xyXG4gICAgICAgICAgICBuZ01vZHVsZTogU25FbnZNb2R1bGUsXHJcbiAgICAgICAgICAgIHByb3ZpZGVyczogW3sgcHJvdmlkZTogQ09ORklHLCB1c2VWYWx1ZTogY29uZmlnIH1dXHJcbiAgICAgICAgfTtcclxuICAgIH1cclxufVxyXG4iXX0=